import { useSearchParams } from "react-router-dom";

import {
  isClientInvitationSignupFlow,
  isPostPublicApplicationRegisterFlow,
} from "../../utils";

export const useRegisterFlow = () => {
  const [params] = useSearchParams();
  const isPostPublicApplicationSignup =
    isPostPublicApplicationRegisterFlow(params);
  const isClientInvitationSignup = isClientInvitationSignupFlow(params);

  return { isPostPublicApplicationSignup, isClientInvitationSignup };
};
